const { commonConfig } = require('@alfa-bank/assr-common-config');
const { cdnPlugin } = require('@plotva/assr-core-plugins');
const { captureConsoleIntegration, browserTracingIntegration } = require('@sentry/browser');

const { clearView } = require('./src/counters/ytm.cjs');
const { favicon } = require('./src/favicon.cjs');

const { name, version, dependencies, resolutions } = require('./package.json');

const getCounters = (url, data) => {
    const counters = commonConfig.getCounters(url, data);
    const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
    const enableYtm = ENABLE_COUNTERS === 'true' && CUSTOM_YTM_ID;

    return {
        ...counters,
        bodyCounters: enableYtm ? [...counters.bodyCounters, clearView] : counters.bodyCounters
    };
};

/** @type {import('@plotva/assr-core').IAssrConfig} */
const config = {
    ...commonConfig,
    postcss: {
        customPropertiesFile: 'node_modules/@alfalab/core-components-themes/site.css'
    },
    cssHashLen: 5,
    widgetsContexts: ['@alfa-bank', '@plotva'],
    additionalWidgetPackages: [],
    instanceName: name,
    instanceVersion: version,
    getDependencies: () => ({ ...dependencies, ...resolutions }),
    plugins: [
        {
            plugin: cdnPlugin,

            config: {
                cdnPublicPath: process.env.CDN_PUBLIC_PATH,
                domainPattern: '(https?:)?//alfabank[.]st'
            }
        }
    ],
    getCounters,
    getFavicon: () => favicon,
    sentry: {
        client: {
            enabled: true,
            sampleRate: 0.5,
            normalizeDepth: 4,
            tracesSampleRate: 0.05,
            integrations: [
                captureConsoleIntegration({ levels: ['error'] }),
                browserTracingIntegration()
            ]
        }
    }
};

module.exports = config;
